import { render, staticRenderFns } from "./InstitutionForm.vue?vue&type=template&id=337dbb53&scoped=true&"
import script from "./InstitutionForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=337dbb53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337dbb53",
  null
  
)

export default component.exports